(function () {
  document.addEventListener('product:variant-change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-product-purchase-social-proof]').forEach(function (container) {
      var messages = container.querySelectorAll('[data-product-purchase-social-proof-variant]');
      var hasMessage = false;

      messages.forEach(function (message) {
        var isSelected = message.dataset.productPurchaseSocialProofVariant === String(variant.id);
        message.hidden = !isSelected;
        hasMessage = hasMessage || isSelected;
      });

      container.hidden = !hasMessage;
    });
  });
})();
